/**
 * 会员默认资源设置页面
 */
export const MEMBER_DEFAULT_RESOURCE_PAGE_PATH = '/member/default/resource'
